<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Siniestros en cobranza directa</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            
            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                          label-for="fdesde" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde"
                          :disabled="campoBloqueado('fdesde', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                  </b-input-group>
              </b-form-group>    

              <b-form-group
                :label="crearLabel('Ejecutivo', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo">
                <b-form-select 
                  :options="valEjecutivos"  
                  v-model="datosFormulario.ejecutivo"
                  :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.codejecutivo }}
                </span>
              </b-form-group>  
            </b-col>

            <b-col sm="3" >  
              <b-form-group :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                          label-for="fhasta" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta"
                          :disabled="campoBloqueado('fhasta', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                  </b-input-group>
              </b-form-group>    

            </b-col>
            <b-col sm="6">  
                <b-form-group
                    :label="crearLabel('Pólizas', 'polizas', 'datosFormulario')"
                    label-for="polizas">
                    <multiselect 
                        v-model="value" 
                        tag-placeholder="Seleccionar póliza" 
                        placeholder="Buscar póliza" 
                        label="name" 
                        track-by="code" 
                        :options="valPolizas" 
                        :multiple="true" 
                        :taggable="true" 
                        @tag="addTag">
                    </multiselect>
                    <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.poliza }}
                    </span>
                </b-form-group>
           </b-col>  
             
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Siniestros en cobranza directa</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "TareasActividades",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "SiniestrosEnCobranzaDirecta",
      titles: [
        {
          prop: "Correlativo",
          label: "#",
          align: "right",
          minwidth:'70'
        },
        {
          prop: "DIG.",
          label: "DIG.",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "EJEC.",
          label: "EJEC.",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "Fecha mail",
          label: "Fecha mail",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Producto",
          label: "Producto",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "Póliza",
          label: "Póliza",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Siniestro",
          label: "Siniestro",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Asegurado",
          label: "Asegurado",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Beneficiario",
          label: "Beneficiario",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Deudor",
          label: "Deudor",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Monto Impago",
          label: "Monto Impago CLP",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Fecha Castigo",
          label: "Fecha Castigo",
          align: "left",
          minwidth:'120'
        }
      ],
      filters: [
        {
          prop: ["Correlativo",
                "DIG.",
                "EJEC.",
                "Fecha mail",
                "Producto",
                "Póliza",
                "Siniestro",
                "Asegurado",
                "Beneficiario",
                "Deudor",
                "Monto Impago",
                "Fecha Castigo"
                 ],
          value: ""
        }
      ],

      datosFormulario: {},
      valPolizas: [],
      valEjecutivos: [],
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      return apiInformes
        .pre_insercion_sinicobdirecta(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
              this.datosFormulario.ejecutivo = lista_data[i]["codejecutivo"];
          }
         
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de polizas
          var tiposPolizas = new Array();
          var lista_tipos_polizas = response.data.poliza;
          for(var i = 0; i < lista_tipos_polizas.length; i++){
              var obj = new Object();
              obj.name = lista_tipos_polizas[i]["poliza"];
              obj.code = lista_tipos_polizas[i]["poliza"];
              tiposPolizas.push(obj);
          }
          this.valPolizas = tiposPolizas;

          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["des_ejecutivo"];
              tiposEjecutivos.push(obj);
          }
          this.valEjecutivos = tiposEjecutivos;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      //Carga lista de polizas
      if (this.value != null && this.value != ""){
        var seleccionPolizas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionPolizas += "," + this.value[i]["code"];
        }
        seleccionPolizas = seleccionPolizas.substring(1,seleccionPolizas.length);
      }else{
        seleccionPolizas = "0";
      }
      

      return apiInformes
        .recuperar_sinicobdirecta
        (
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.ejecutivo,
          seleccionPolizas,
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta
        )
        .then(response => {
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
            /*
            var ii = 0;
            var aux = 0;
            for(var i = 0; i < response.data.res1.length; i++){
                if (this.data[i]["Anio mail"] != aux){
                  ii = 0;
                }
                aux = this.data[i]["Anio mail"];
                ii += 1
                this.data[i]["Correlativo"] = ii;
            }*/

          } else {
            this.exportar = false;
          }

          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha mail" ||
           column.property == "Fecha Castigo"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Monto Impago"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      //Carga lista de polizas
      if (this.value != null && this.value != ""){
        var seleccionPolizas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionPolizas += "," + this.value[i]["code"];
        }
        seleccionPolizas = seleccionPolizas.substring(1,seleccionPolizas.length);
      }else{
        seleccionPolizas = "Todas";
      }

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Siniestros en cobranza directa</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >"+"Fecha desde: "+ this.convierteFecha(this.datosFormulario.fdesde)+ " Fecha Hasta: "+this.convierteFecha(this.datosFormulario.fhasta)+" Polizas: "+seleccionPolizas+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          
          if(this.data[key]["Correlativo"] == undefined){
              this.data[key]["Correlativo"] = "";
          }
          if(this.data[key]["DIG."] == undefined){
              this.data[key]["DIG."] = "";
          }
          if(this.data[key]["EJEC."] == undefined){
              this.data[key]["EJEC."] = "";
          }
          if(this.data[key]["Fecha mail"] == undefined){
              this.data[key]["Fecha mail"] = "";
          }
          if(this.data[key]["Producto"] == undefined){
              this.data[key]["Producto"] = "";
          }
          if(this.data[key]["Siniestro"] == undefined){
              this.data[key]["Siniestro"] = "";
          }
          if(this.data[key]["Póliza"] == undefined){
              this.data[key]["Póliza"] = "";
          }
          if(this.data[key]["Asegurado"] == undefined){
              this.data[key]["Asegurado"] = "";
          }
          if(this.data[key]["Beneficiario"] == undefined){
              this.data[key]["Beneficiario"] = "";
          }
          if(this.data[key]["Deudor"] == undefined){
              this.data[key]["Deudor"] = "";
          }
          if(this.data[key]["Monto Impago"] == undefined){
              this.data[key]["Monto Impago"] = "";
          }
          if(this.data[key]["Fecha Castigo"] == undefined){
              this.data[key]["Fecha Castigo"] = "";
          }

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Correlativo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["DIG."]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["EJEC."]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha mail"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Producto"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Póliza"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Siniestro"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Asegurado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Beneficiario"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Deudor"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Impago"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Castigo"])+"</td>\n";
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}
</style>
